// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hoverButton {
  background-color: #d9d9d9;
}

.alignButtonEditAndReload {
  display: grid;
  grid-template-columns: 1, 5fr 1fr;
  justify-content: space-between;
  margin: 15px 0px;
}

.buttonView {
  display: flex;
  gap: 10px;
  margin-bottom: 30px;
}

.alignButtonReload {
  display: flex;
  margin-left: 15px;
  width: 100%;
}

.alignButtonsExit {
  display: flex;
  margin-top: 40px;
  width: 600px;
  justify-content: center;
}

.none {
  display: none;
}

.topGreen .modal {
  border-top: 6px solid #007bc0;
  min-width: 550px;
}

.widthGreen {
  width: 100%;
}

.widthGreen .titleDescription {
  font-size: 22px;
}

.widthGreen img {
  display: none;
}

.widthGreen .buttonsEdit {
  padding-top: 45px;
}

.widthGreen .buttonGenericCustom {
  width: 170px;
}

.widthGreen .buttonAux {
  width: 130px;
}

.widthGreen .buttonGenericCustom.tes {
  width: 110px;
}

.responseQuestions {
  margin: 15px 35px 0 0;
  width: 100%;
}

.responseQuestions h2 {
  font-size: 14px;
  font-weight: 500;
}

.containerData {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  padding: 20px 20px 20px 30px;
  margin: 25px 25px 0px 0px;
}

.titleDataView {
  font-size: 19px;
  margin-top: 18px;
  margin-bottom: 5px;
}

.containerText {
  width: 100%;
  text-align: justify;
}

.header-page .suggestion {
  border-bottom: 1px dashed #000;
  padding-bottom: 2px;
}

.container-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 70%;
}

.paginationControls {
  display: flex;
  align-items: center;
}

.paginationControls button {
  margin: 0 5px;
  padding: 5px 10px;
  font-weight: 400;
  font-size: 15px;
  cursor: pointer;
}

.paginationControls img {
  width: 30px;
  height: 30px;
}

.paginationControls button.active {
  font-weight: bold;
  background-color: #007bc0;
  border-radius: 50%;
  color: white;
}

.aignButtonReload {
  display: flex;
}

.modalRefazer .titleDescription {
  margin-bottom: 5px;
}

.titleDescription {
  font-size: 18px;
  font-weight: 700;
  margin: 10px 0px 20px 0px;
}

.titleDescriptions {
  font-size: 18px;
  font-weight: 700;
  margin: 10px 0px 15px 0px;
}

.buttonAux {
  background-color: #007bc0;
}

.buttonAux span {
  color: #fff;
}

.buttonGenericCustom:hover span {
  color: #007bc0;
}

.buttonGenericCustom.buttonHover:hover span {
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/componentes/fluxo-nsimilar/Steps/steps.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".hoverButton {\n  background-color: #d9d9d9;\n}\n\n.alignButtonEditAndReload {\n  display: grid;\n  grid-template-columns: 1, 5fr 1fr;\n  justify-content: space-between;\n  margin: 15px 0px;\n}\n\n.buttonView {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 30px;\n}\n\n.alignButtonReload {\n  display: flex;\n  margin-left: 15px;\n  width: 100%;\n}\n\n.alignButtonsExit {\n  display: flex;\n  margin-top: 40px;\n  width: 600px;\n  justify-content: center;\n}\n\n.none {\n  display: none;\n}\n\n.topGreen .modal {\n  border-top: 6px solid #007bc0;\n  min-width: 550px;\n}\n\n.widthGreen {\n  width: 100%;\n}\n\n.widthGreen .titleDescription {\n  font-size: 22px;\n}\n\n.widthGreen img {\n  display: none;\n}\n\n.widthGreen .buttonsEdit {\n  padding-top: 45px;\n}\n\n.widthGreen .buttonGenericCustom {\n  width: 170px;\n}\n\n.widthGreen .buttonAux {\n  width: 130px;\n}\n\n.widthGreen .buttonGenericCustom.tes {\n  width: 110px;\n}\n\n.responseQuestions {\n  margin: 15px 35px 0 0;\n  width: 100%;\n}\n\n.responseQuestions h2 {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.containerData {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n  padding: 20px 20px 20px 30px;\n  margin: 25px 25px 0px 0px;\n}\n\n.titleDataView {\n  font-size: 19px;\n  margin-top: 18px;\n  margin-bottom: 5px;\n}\n\n.containerText {\n  width: 100%;\n  text-align: justify;\n}\n\n.header-page .suggestion {\n  border-bottom: 1px dashed #000;\n  padding-bottom: 2px;\n}\n\n.container-button {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 70%;\n}\n\n.paginationControls {\n  display: flex;\n  align-items: center;\n}\n\n.paginationControls button {\n  margin: 0 5px;\n  padding: 5px 10px;\n  font-weight: 400;\n  font-size: 15px;\n  cursor: pointer;\n}\n\n.paginationControls img {\n  width: 30px;\n  height: 30px;\n}\n\n.paginationControls button.active {\n  font-weight: bold;\n  background-color: #007bc0;\n  border-radius: 50%;\n  color: white;\n}\n\n.aignButtonReload {\n  display: flex;\n}\n\n.modalRefazer .titleDescription {\n  margin-bottom: 5px;\n}\n\n.titleDescription {\n  font-size: 18px;\n  font-weight: 700;\n  margin: 10px 0px 20px 0px;\n}\n\n.titleDescriptions {\n  font-size: 18px;\n  font-weight: 700;\n  margin: 10px 0px 15px 0px;\n}\n\n.buttonAux {\n  background-color: #007bc0;\n}\n\n.buttonAux span {\n  color: #fff;\n}\n\n.buttonGenericCustom:hover span {\n  color: #007bc0;\n}\n\n.buttonGenericCustom.buttonHover:hover span {\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
